import { Flame, Phone, Mail, MapPin } from 'lucide-react'

const footerLinks = {
  products: [
    { name: '风暖炉', href: '/products' },
    { name: '水暖炉', href: '/products' },
    { name: '燃烧机', href: '/products' },
    { name: '燃木壁炉', href: '/products' },
  ],
  resources: [
    { name: '说明书', href: '#resources' },
    { name: '操作视频', href: '#resources' },
    { name: '维修视频', href: '#resources' },
    { name: '宣传片', href: '#resources' },
  ],
  company: [
    { name: '关于我们', href: '/about' },
    { name: '企业文化', href: '/company-detail' },
    { name: '资质荣誉', href: '/company-detail' },
    { name: '新闻动态', href: '/news' },
    { name: '加入我们', href: '#' },
  ],
  service: [
    { name: '技术支持', href: '/resources' },
    { name: '售后服务', href: 'https://www.yuque.com/huanbaogongchengguo/xccdgh/ukkklss0btan7fvp' },
    { name: '常见问题', href: 'https://www.yuque.com/huanbaogongchengguo/xccdgh/ukkklss0btan7fvp' },
  ],
}

export default function Footer() {
  const currentYear = new Date().getFullYear()

  const scrollToSection = (href: string) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <footer className="bg-secondary-950 text-white pb-20 md:pb-0">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2.5 rounded-xl bg-primary-600">
                <Flame className="w-7 h-7 text-white" />
              </div>
              <div>
                <span className="text-xl font-bold">云净炉业</span>
                <span className="block text-xs text-secondary-400">YUNJING FURNACE</span>
              </div>
            </div>
            <p className="text-secondary-400 text-sm leading-relaxed mb-6 max-w-sm">
              专注于工业炉设备的研发与制造，致力于为客户提供高效、节能、环保的加热解决方案，
              引领清洁能源新时代。
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-secondary-400">
                <Phone className="w-4 h-4 text-primary-400" />
                <span>4009850539</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-secondary-400">
                <Mail className="w-4 h-4 text-primary-400" />
                <span>1380632@gmail.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-secondary-400">
                <MapPin className="w-4 h-4 text-primary-400" />
                <span>山东省临沂市沂河新区</span>
              </div>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold text-white mb-5">产品中心</h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  {link.href.startsWith('/') && !link.href.startsWith('#') ? (
                    <a
                      href={link.href}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-white mb-5">资料中心</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-5">关于公司</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  {link.href.startsWith('/') && !link.href.startsWith('#') ? (
                    <a
                      href={link.href}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Service */}
          <div className="lg:col-span-1">
            <h4 className="font-semibold text-white mb-5">服务支持</h4>
            <ul className="space-y-3">
              {footerLinks.service.map((link) => (
                <li key={link.name}>
                  {link.href.startsWith('http') ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : link.href.startsWith('/') && !link.href.startsWith('#') ? (
                    <a
                      href={link.href}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                    >
                      {link.name}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-500">
              {currentYear} 云净炉业有限公司 版权所有 | 
              <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-primary-400 transition-colors"
              >
                鲁ICP备2022015622号-2
              </a>
            </p>
            <div className="flex items-center gap-6 text-sm text-secondary-500">
              <a 
                href="https://b37q1va5za.ai-app.pub" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-primary-400 transition-colors"
              >
                在线办公
              </a>
              <button className="hover:text-primary-400 transition-colors">隐私政策</button>
              <button className="hover:text-primary-400 transition-colors">服务条款</button>
              <button className="hover:text-primary-400 transition-colors">网站地图</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
